import { ApiData } from '@cawita/core-front/api';
import { Partner } from './partner.model';
import { User } from './user.model';
import { CwtModel } from '@shared/modules/crud';

@CwtModel({ name: 'event-subscription', path: '/event' })
export class EventSubscription extends ApiData {
    user?: User;
    partner?: Partner;
    event?: Event;
    hasBeenNotified?: boolean;
    public targetDate?: Date;
    public actualDate?: Date;
}
